<template>
  <div style="width: 100%">
    <div class="echart-title">
      <div class="title-name">{{$t('GovernmentRegulation.overview')}}</div>
      <el-row :gutter="20" class="title-content">
        <div v-for="(title, index) in titles" :key="index">
          <div class="content-one">
            <div :class="line[index]"></div>
            <div>
              <div :class="oneDown[index]">
                {{ title.number | NumFormat }}
              </div>
              <div class="one-up">{{ title.title }}</div>
            </div>
          </div>
        </div>
      </el-row>
    </div>
    <el-row :gutter="20" class="echart-all" style="margin-top: 16px !important">
      <el-col :span="16" style="padding-left: 0">
        <div class="all-left">
          <div class="left-title" v-if="isPrimaryKey('SECURE_ECHARTS_DOWN')">
            {{$t('GovernmentRegulation.violationTrend')}}<span class="title-down" @click="down">{{$t('common.btn.download')}}</span>
          </div>
          <div v-if="isLine" v-loading="lineLoading">
            <linegraph
              :id="'linegraph2'"
              :data="optionLine"
              style="height: 300px"
            ></linegraph>
          </div>
          <div
            v-else
            style="
              color: #868686;
              font-size: 16px;
              text-align: center;
              line-height: 300px;
            "
          >
            {{$t('GovernmentRegulation.noData')}}
          </div>
        </div>
      </el-col>
      <el-col :span="8" style="padding-right: 0">
        <div class="all-left">
          <div class="left-title">{{$t('GovernmentRegulation.violationRatio')}}</div>
          <div v-loading="pieLoading">
            <linegraph
              v-loading="pieLoading"
              :id="'piegraph'"
              :data="optionPie"
              style="height: 300px"
            ></linegraph>
          </div>
        </div>
      </el-col>
    </el-row>
    <div class="dataTable">
      <div class="table-title">{{$t('GovernmentRegulation.companyViolationAnalysis')}}</div>
      <div class="rightAll-btn" style="padding: 10px 0 0">
        <el-form :inline="true" :model="formInline" class="demo-form-inline">
          <el-form-item :label="$t('ContractManagement.contractId')">
            <el-input
              size="mini"
              v-model="formInline.companyName"
              :placeholder="$t('GovernmentRegulation.form.companyName')"
              style="width: 150px"
              class="input-with-select"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-button
              size="mini"
              type="primary"
              @click="onSearch"
              class="btn-chaxun"
              >{{$t('common.btn.search')}}</el-button
            >
            <el-button size="mini" @click="onClear" class="btn-del"
              >{{$t('common.btn.cancel')}}</el-button
        >
          </el-form-item>
        </el-form>
        <el-button v-if="isPrimaryKey('SECURE_DOWN')" type="text" @click="downCar" style="float: right"
          >{{$t('common.btn.download')}}</el-button
        >
      </div>
      <i-table
        :list="list"
        ref="carTable"
        @handleSelectionChange="handleSelectionChange"
        :options="option"
        :columns="columns"
        :operates="operates"
      ></i-table>
      <IPagination ref="page" @PageFun="changeSize"></IPagination>
    </div>
    <el-dialog
      width="1200px"
      :before-close="closeOperateDia"
      class="tableDialong"
      :title="$t('GovernmentRegulation.carViolationDetail')"
      :visible.sync="dialogOperateFormVisible"
      :close-on-click-modal="false"
    >
      <div class="zMsgSearch">
        <el-form :inline="true" :model="formTable" class="demo-form-inline">
          <el-form-item :label="$t('common.carId')">
            <el-input
              size="mini"
              v-model="formTable.carId"
              :placeholder="$t('common.searchTip')"
              style="width: 150px"
              class="input-with-select"
            ></el-input>
          </el-form-item>
          <el-form-item :label="$t('common.plateNum')">
            <el-input
              size="mini"
              v-model="formTable.plateNum"
              :placeholder="$t('common.searchTip')"
              style="width: 150px"
              class="input-with-select"
            ></el-input>
          </el-form-item>
          <el-form-item :label="$t('common.driverName')">
            <el-input
              size="mini"
              v-model="formTable.driverName"
              :placeholder="$t('common.searchTip')"
              style="width: 150px"
              class="input-with-select"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-button
              size="mini"
              type="primary"
              @click="Search"
              class="btn-chaxun"
              >{{$t('common.btn.search')}}</el-button
            >
            <el-button size="mini" @click="Clear" class="btn-del"
              >{{$t('common.btn.cancel')}}</el-button
        >
          </el-form-item>
        </el-form>
      </div>
      <div class="zMsgBtn">
        <el-button type="text" @click="downOperate">{{$t('common.btn.download')}}</el-button>
      </div>
      <div class="zMsgTable">
        <i-table
          :list="operatesList"
          :height="operatesHeight"
          ref="operatesTable"
          :options="allOption"
          :columns="allColumns"
          :operates="allOperates"
        ></i-table>
        <IPagination
          ref="OperatesPage"
          @PageFun="changeOperatesSize"
        ></IPagination>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import MonthTime from "./MonthTime";
export default MonthTime;
</script>

<style lang="less" scoped>
@import "../../../../../assets/styles/Style.less";
</style>
